import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import SEO from './SEO';
import { toolsSEO } from '../config/seoConfig';
import '../styles/App.css';

interface ToolLayoutProps {
  title: string;
  description: string;
  children: React.ReactNode;
}

const ToolLayout: React.FC<ToolLayoutProps> = ({ title, description, children }) => {
  const { theme, toggleTheme } = useTheme();
  const location = useLocation();

  // Get tool ID from pathname
  const toolId = location.pathname.replace('/', '');
  const seoData = toolsSEO[toolId];

  return (
    <>
      {seoData && (
        <SEO
          title={seoData.title}
          description={seoData.description}
          keywords={seoData.keywords}
          canonicalUrl={`https://devtools.eduone.asia${location.pathname}`}
        />
      )}
      <div className="tool-page">
        <div className="tool-container">
          <div className="tool-header">
            <div className="header-top">
              <Link to="/" className="back-button">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M19 12H5M12 19l-7-7 7-7"/>
                </svg>
                Back to Dashboard
              </Link>
              <button onClick={toggleTheme} className="theme-toggle" aria-label="Toggle theme">
                {theme === 'light' ? (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
                  </svg>
                ) : (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="5"/>
                    <path d="M12 1v2m0 18v2M4.22 4.22l1.42 1.42m12.72 12.72l1.42 1.42M1 12h2m18 0h2M4.22 19.78l1.42-1.42m12.72-12.72l1.42-1.42"/>
                  </svg>
                )}
              </button>
            </div>
            <h1 className="tool-title">{title}</h1>
            <p className="tool-description-text">{description}</p>
          </div>

          <div className="tool-content">
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default ToolLayout;

